export default "__VITE_ASSET__d9ac1b9a__"